import { Link } from 'react-router-dom';

interface MovieCardProps {
  id: number;
  title: string;
  cover: string;
  rating: number;
  year: number;
  tags: string[];
  updateDate?: string;
}

export default function MovieCard({ id, title, cover, rating, year, tags, updateDate }: MovieCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          title={`${title} - 屁屁影院高清在线观看`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute top-2 left-2">
          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-primary-500/90 text-white text-xs font-semibold">
            <i className="ri-star-fill text-[10px]"></i>
            {rating}
          </span>
        </div>
        {updateDate && (
          <div className="absolute top-2 right-2">
            <span className="inline-flex items-center px-2 py-0.5 rounded-md bg-background-950/70 text-white text-[10px]">
              {updateDate}
            </span>
          </div>
        )}
        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <div className="flex flex-wrap gap-1">
            {tags.map((tag) => (
              <span
                key={tag}
                className="px-2 py-0.5 rounded-full bg-white/20 text-white text-[10px] backdrop-blur-sm"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{year}</p>
      </div>
    </Link>
  );
}